(function () {
  function getClosest(element, selector) {
    if (!element) return null;
    return element.closest(selector);
  }

  function updateSort(value) {
    var url = new URL(window.location.href);

    if (value) {
      url.searchParams.set('sort_by', value);
    } else {
      url.searchParams.delete('sort_by');
    }

    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function openFilters() {
    var panel = document.querySelector('[data-og-facets]');
    if (!panel) return;

    panel.classList.add('is-open');
    document.body.classList.add('og-filters-open');
  }

  function closeFilters() {
    var panel = document.querySelector('[data-og-facets]');
    if (!panel) return;

    panel.classList.remove('is-open');
    document.body.classList.remove('og-filters-open');
  }

  function setView(view) {
    var buttons = document.querySelectorAll('[data-og-view]');

    buttons.forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-og-view') === view);
    });

    document.body.classList.toggle('og-list-view', view === 'list');

    try {
      window.localStorage.setItem('ogCollectionView', view);
    } catch (error) {}
  }

  document.addEventListener('change', function (event) {
    var sortSelect = getClosest(event.target, '[data-og-sort-select]');

    if (sortSelect) {
      updateSort(sortSelect.value);
      return;
    }

    var filterInput = getClosest(event.target, '.og-filter-option__input');

    if (filterInput) {
      var form = document.getElementById('OgFacetForm');
      if (form) {
        form.submit();
      }
    }
  });

  document.addEventListener('click', function (event) {
    var openBtn = getClosest(event.target, '[data-og-open-filters]');
    if (openBtn) {
      openFilters();
      return;
    }

    var closeBtn = getClosest(event.target, '[data-og-close-filters]');
    if (closeBtn) {
      closeFilters();
      return;
    }

    // var compareBtn = getClosest(event.target, '[data-og-compare-toggle]');
    // if (compareBtn) {
    //   var isPressed = compareBtn.getAttribute('aria-pressed') === 'true';
    //   compareBtn.setAttribute('aria-pressed', String(!isPressed));
    //   document.body.classList.toggle('og-compare-on', !isPressed);
    //   return;
    // }

    var viewBtn = getClosest(event.target, '[data-og-view]');
    if (viewBtn) {
      setView(viewBtn.getAttribute('data-og-view'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFilters();
    }
  });

  // document.addEventListener('DOMContentLoaded', function () {
  //   try {
  //     var savedView = window.localStorage.getItem('ogCollectionView');
  //     if (savedView === 'list') {
  //       setView('list');
  //     } else {
  //       setView('grid');
  //     }
  //   } catch (error) {
  //     setView('grid');
  //   }
  // });

document.addEventListener('DOMContentLoaded', function () {
  setView('grid');
});   //这样页面默认永远是正常四列网格，只有用户点击列表图标时才切换到列表模式。

})();